import uuid from 'uuid'
import {
  Message
} from 'element-ui'
import {
  getSurvey
} from '@/api/survey'
import moment from 'moment'


function getEmptySurveyBody() {
  return {
    id: uuid(Date.parse(new Date())),
    title: '问卷标题',
    prefix: '感谢您能抽出几分钟时间来参加本次答题，现在我们就马上开始吧！',
    head_img: '', // 头部图片
    questions: []
  }
}

const survey = {
  state: {
    activeQuestion: {},
    activeOption: {},
    activeIndex: -1, // 当前选中的 Question 的 index, -1 代表还未有任何题目
    activeOptionIndex: 0,
    bubbleParameter: {},
    surveyBody: getEmptySurveyBody()
  },
  mutations: {
    SET_SURVEY_SETTING(state, data) {
      state.surveyBody[data.key] = data.value
    },
    SET_ACTIVEQUESTION(state, data) {
      state.activeQuestion = data
    },
    SET_ACTIVEOPTION(state, data) {
      state.activeOption = data
    },
    SET_ACTIVEINDEX(state, data) {
      state.activeIndex = data
    },
    SET_ACTIVEOPTIONINDEX(state, data) {
      state.activeOptionIndex = data
    },
    SET_BUBBLEPARAMETER(state, data) {
      state.bubbleParameter = data
    },
    SET_SURVEY_BODY(state, data) {
      state.surveyBody = data
    },
    ADD_QUESTION(state, data) {
      state.surveyBody.questions.splice(state.activeIndex + 1, 0, data)
      state.activeIndex += 1
    },
    DEL_QUESTION(state, index) {
      let question = state.surveyBody.questions
      // let questionIndex = question.map(item => item.id).indexOf(data)
      question.splice(index, 1)
    },
    ADD_OPTION(state, data) {
      let option = state.surveyBody.questions.filter(
        item => item.id === data.id
      )[0].options
      data.option.map(item => {
        if (item.text === '') return (item.text = '选项 ' + (option.length + 1))
      })
      option.push(...data.option)
    },
    DEL_OPTION(state, data) {
      let option = state.surveyBody.questions.filter(
        item => item.id === data.qid
      )[0].options
      let optionIndex = option.map(item => item.id).indexOf(data.oid)
      option.splice(optionIndex, 1)
    },
    UPDATE_LOGIC_BEFORE_DEL_QUESTION(state, index) {
      // 如果是填空题则不做任何处理
      if (state.activeQuestion.type === 'input') {
        return
      }
      // 如果是单选、多选、下拉题
      let questions = state.surveyBody.questions
      const currentQuestionOptions = state.activeQuestion.options.map(
        item => item.id
      )
      for (let i = index + 1; i < questions.length; i++) {
        let options = questions[i].setting.visibility.visible.options
        // 求属于 A 但是不属于 B 的差集
        const difference = options
          .concat(currentQuestionOptions)
          .filter(
            v => options.includes(v) && !currentQuestionOptions.includes(v)
          )
        questions[i].setting.visibility.visible.options = difference
      }
    },
    UPDATE_LOGIC_BEFORE_DEL_OPTION(state, data) {
      const qindex = data.qindex
      const oid = data.oid
      let questions = state.surveyBody.questions
      const currentQuestionOptions = [oid]
      for (let i = qindex + 1; i < questions.length; i++) {
        let options = questions[i].setting.visibility.visible.options
        // 求属于 A 但是不属于 B 的差集
        const difference = options
          .concat(currentQuestionOptions)
          .filter(
            v => options.includes(v) && !currentQuestionOptions.includes(v)
          )
        questions[i].setting.visibility.visible.options = difference
      }
    },

    // ---------------------------------------------------------------------------
    // 问题被拖动的时候，需要更新受影响的问题的 logic option
    // data  = [oldIndex, newIndex]
    // ---------------------------------------------------------------------------
    UPDATE_LOGIC_AFTER_DRAG(state, indecies) {
      const oldIndex = indecies[0]
      const newIndex = indecies[1]

      let questions = state.surveyBody.questions

      // 如果该题目被移动至第一题，则 logic option 为空
      if (newIndex === 0) {
        questions[0].setting.visibility.visible.options = []
        return
      }

      // 如果是向上移动，只需要考虑被移动的那一个Question
      if (oldIndex > newIndex) {
        const questionsBefore = state.surveyBody.questions.slice(0, newIndex)
        const optionsBefore = questionsBefore
          .map(question => {
            return question.options.map(option => option.id)
          })
          .flat()
        // optionBefore 与当前的问题的logic options 取并集
        let options = questions[newIndex].setting.visibility.visible.options

        const same = options.filter(v => optionsBefore.includes(v))
        questions[newIndex].setting.visibility.visible.options = same
      }

      // 如果是向下移动，则需要考虑，[oldIndex，newIndex) 之间的 Question
      if (oldIndex < newIndex) {
        // 此处无需考虑 i = large 的情况
        for (let i = oldIndex; i < newIndex; i++) {
          if (i === 0) {
            questions[i].setting.visibility.visible.options = []
          } else {
            const questionsBefore = state.surveyBody.questions.slice(0, i)
            const optionsBefore = questionsBefore
              .map(question => {
                return question.options.map(option => option.id)
              })
              .flat()
            // optionBefore 与当前的问题的logic options 取并集
            let options = questions[i].setting.visibility.visible.options

            const same = options
              .concat(optionsBefore)
              .filter(v => options.includes(v) && optionsBefore.includes(v))
            questions[i].setting.visibility.visible.options = same
          }
        }
      }
    }
  },
  actions: {
    setSurveySetting({
      commit
    }, data) {
      commit('SET_SURVEY_SETTING', data)
    },
    // -----------------------------------------------------------------------------
    // TODO 撰写注释
    // -----------------------------------------------------------------------------
    setActiveQuestion({
      commit
    }, data) {
      commit('SET_ACTIVEQUESTION', data)
    },

    // -----------------------------------------------------------------------------
    // TODO 撰写注释
    // -----------------------------------------------------------------------------
    setActiveOption({
      commit
    }, data) {
      commit('SET_ACTIVEOPTION', data)
    },

    // -----------------------------------------------------------------------------
    // TODO 撰写注释
    // -----------------------------------------------------------------------------
    setActiveIndex({
      commit
    }, data) {
      commit('SET_ACTIVEINDEX', data)
    },

    // -----------------------------------------------------------------------------
    // TODO 撰写注释
    // -----------------------------------------------------------------------------
    setActiveOptionIndex({
      commit
    }, data) {
      commit('SET_ACTIVEOPTIONINDEX', data)
    },

    // -----------------------------------------------------------------------------
    // TODO 撰写注释
    // -----------------------------------------------------------------------------
    setBubbleParameter({
      commit
    }, data) {
      commit('SET_BUBBLEPARAMETER', data)
    },

    // -----------------------------------------------------------------------------
    // 设置 SurveyBody
    // -----------------------------------------------------------------------------
    setSurveyBody({
      commit
    }, data) {
      commit('SET_SURVEY_BODY', data)
    },

    // -----------------------------------------------------------------------------
    // 设置一个空的 SurveyBody
    // -----------------------------------------------------------------------------
    setEmptySurveyBody({
      commit
    }) {
      commit('SET_SURVEY_BODY', getEmptySurveyBody())
    },

    // -----------------------------------------------------------------------------
    // 添加一个题目
    // -----------------------------------------------------------------------------
    addQuestion({
      commit
    }, data) {
      commit('ADD_QUESTION', data)
      commit('SET_ACTIVEQUESTION', data)
    },

    // -----------------------------------------------------------------------------
    // 删除问题。删除一个问题时，需要删除该问题之后所有跟其有逻辑关系的问题的 visibility 中的 option
    // -----------------------------------------------------------------------------
    delQuestion({
      commit
    }, index) {
      commit('UPDATE_LOGIC_BEFORE_DEL_QUESTION', index)
      commit('DEL_QUESTION', index)
    },
    addOption({
      commit
    }, data) {
      commit('ADD_OPTION', data)
    },

    // -----------------------------------------------------------------------------
    //  删除一个选项。删除一个选项时，需要删除该问题之后所有跟其有逻辑关系的问题的 visibility 中的 option
    // -----------------------------------------------------------------------------
    delOption({
      commit
    }, data) {
      commit('UPDATE_LOGIC_BEFORE_DEL_OPTION', data)
      commit('DEL_OPTION', data)
    },

    // -----------------------------------------------------------------------------
    //  题目拖动后更新逻辑
    // -----------------------------------------------------------------------------
    updateLogicAfterDrag({
      commit
    }, indecies) {
      // 按从小到大排序
      if (indecies[0] === indecies[1]) return
      commit('UPDATE_LOGIC_AFTER_DRAG', indecies)
      commit('SET_ACTIVEQUESTION', indecies[1])
    },

    setSurveyBodyTimeRange({
      commit
    }, timeRange) {
      if (timeRange) {
        const [started_at, ended_at] = timeRange
        commit('SET_SURVEY_SETTING', {
          key: 'started_at',
          value: started_at
        })
        commit('SET_SURVEY_SETTING', {
          key: 'ended_at',
          value: ended_at
        })
      } else {
        commit('SET_SURVEY_SETTING', {
          key: 'started_at',
          value: null
        })
        commit('SET_SURVEY_SETTING', {
          key: 'ended_at',
          value: null
        })
      }
    },
    getSurvey({
      commit
    }, id) {
      return getSurvey(id).then(res => {
        res.data.started_at = moment(res.data.started_at).valueOf()
        res.data.ended_at = moment(res.data.ended_at).valueOf()
        commit('SET_SURVEY_BODY', res.data)
      }).catch(err => {
        Message({
          type: 'error',
          message: err.response.data.message,
          center: true,
          duration: 1500
        })
      })
    }
  }
}

export default survey